module.exports = __webpack_public_path__ + "img/CIO210_R.a5aad74a.png";